// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.application-section {
  margin: 0 16.66%;
}
.application-section .btn-link {
  font: 18px "Omnes-ATT-W02";
  padding-top: 10px;
}
.application-section a {
  cursor: pointer;
}
.application-section label {
  font-size: 16px;
}
.application-section h2 {
  font-size: 30px;
  color: #191919;
}
.application-section .pagination {
  padding-bottom: 10px;
}
.application-section .default-app-names {
  margin: 20px 0 20px 35px;
}
.application-section .default-app-names li {
  list-style-type: disc;
  margin-left: 15px;
}
.application-section .search-field {
  display: none !important;
}
.application-section .back {
  padding-right: 30px;
}
.application-section .border-none {
  border: 0 none;
}
.application-section .buttons-section {
  padding: 30px 0 60px;
}
.application-section .accordion {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 0;
}
.application-section .applications-modal ul li {
  list-style-type: disc;
  margin-left: 15px;
}
.application-section tr th:first-child {
  width: 15%;
}
.application-section tr td {
  vertical-align: middle;
}
.application-section tr td:first-child .text-center {
  text-align: center;
}
@media (max-width: 1024px) {
  .application-section {
    margin: 0 15px;
  }
  .application-section .application-btn-cancel {
    padding: 20px 19px 0 18px;
  }
  .application-section .buttons {
    text-align: center;
    width: 100%;
  }
  .application-section .pagination {
    padding-bottom: 0;
  }
  .application-section .buttons-section {
    padding: 20px 0 30px;
  }
  .application-section .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
  .application-section tr th:first-child {
    width: 20%;
  }
  .application-section tr td:first-child .text-center {
    text-align: center;
  }
  .application-section .form-group {
    margin-bottom: 20px;
  }
  .application-section .step-indicator,
  .application-section .alert {
    margin-bottom: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/applications/applications.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,gBAAA;AAkJF;AAhJA;EACI,0BAAA;EACA,iBAAA;AAkJJ;AA/IE;EACE,eAAA;AAiJJ;AA9IE;EACE,eAAA;AAgJJ;AA7IE;EACE,eAAA;EACA,cAAA;AA+IJ;AA7IE;EACE,oBAAA;AA+IJ;AA5IE;EACE,wBAAA;AA8IJ;AA5II;EACE,qBAAA;EACA,iBAAA;AA8IN;AA1IE;EACE,wBAAA;AA4IJ;AAzIE;EACE,mBAAA;AA2IJ;AAxIE;EACE,cAAA;AA0IJ;AAvIE;EAEE,oBAAA;AAwIJ;AArIE;EACE,gCAAA;EACA,gBAAA;AAuIJ;AA9HM;EACE,qBAAA;EACA,iBAAA;AAgIR;AAxHM;EACE,UAAA;AA0HR;AAtHI;EACE,sBAAA;AAwHN;AArHQ;EACE,kBAAA;AAuHV;AFnLI;EErBJ;IAwFI,cAAA;EAoHF;EAlHE;IACE,yBAAA;EAoHJ;EAjHE;IACE,kBAAA;IACA,WAAA;EAmHJ;EAhHE;IACE,iBAAA;EAkHJ;EA/GE;IACE,oBAAA;EAiHJ;EA9GE;IACE,kBAAA;IACA,mBAAA;EAgHJ;EA3GM;IACE,UAAA;EA6GR;EAvGQ;IACE,kBAAA;EAyGV;EAnGE;IACE,mBAAA;EAqGJ;EAlGE;;IAEE,8BAAA;EAoGJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.application-section {\n  margin: 0 16.66%;\n\n.btn-link {\n    font: 18px 'Omnes-ATT-W02';\n    padding-top: 10px;\n  }\n\n  a {\n    cursor: pointer;\n  }\n\n  label {\n    font-size: 16px;\n  }  \n\n  h2{\n    font-size: 30px;\n    color:#191919;\n  }\n  .pagination {\n    padding-bottom: 10px;\n  }\n\n  .default-app-names {\n    margin: 20px 0 20px 35px;\n\n    li {\n      list-style-type: disc;\n      margin-left: 15px;\n    }\n  }\n\n  .search-field {\n    display: none!important;\n  }\n\n  .back {\n    padding-right: 30px;\n  }\n\n  .border-none {\n    border: 0 none;\n  }\n\n  .buttons-section {\n    // border-top: 1px solid color(default, dark);\n    padding: 30px 0 60px;\n  }\n\n  .accordion{\n    border-bottom: 1px solid color(default, dark);\n    margin-bottom: 0;\n  }\n\n  //.accheader{\n  //  font-family: 'Omnes-ATT-W02';\n  //}\n\n  .applications-modal {\n    ul {\n      li {\n        list-style-type: disc;\n        margin-left: 15px;\n      }\n    }\n\n  }\n\n  tr {\n    th {\n      &:first-child {\n        width: 15%;\n      }\n    }\n\n    td {\n      vertical-align: middle;\n\n      &:first-child {\n        .text-center {\n          text-align: center;\n        }\n      }\n    }\n  }\n\n  @include respond-to (small) {\n    margin: 0 15px;\n\n    .application-btn-cancel {\n      padding: 20px 19px 0 18px;\n    }\n\n    .buttons {\n      text-align: center;\n      width: 100%;\n    }\n\n    .pagination {\n      padding-bottom: 0;\n    }\n\n    .buttons-section {\n      padding: 20px 0 30px;\n    }\n\n    .grid-table {\n      margin-left: -15px;\n      margin-right: -15px;\n    }\n\n    tr {\n      th {\n        &:first-child {\n          width: 20%;\n        }\n      }\n\n      td {\n        &:first-child {\n          .text-center {\n            text-align: center;\n          }\n        }\n      }\n    }\n\n    .form-group {\n      margin-bottom: 20px;\n    }\n\n    .step-indicator,\n    .alert {\n      margin-bottom: 30px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
